// Deliverables extension (admin side): the files a digital download hands over.
// The Platforms tab shows for digital downloads as well as for license-key
// products, so it is reachable from here too — the same component, switched
// inside the panel. Both tabs are the old catalog editor's, reused as they are.
import { CloudArrowDownIcon } from "@heroicons/react/24/outline"
import DeliverablesTab from "./DeliverablesTab"
import PlatformsTab from "../shared/PlatformsTab"
import { CatalogEditorProvider, catalogTabsSection, catalogVisible, useCatalogVisibilityContext } from "../shared/catalog-editor"

export const StoreProductExtension = {
  id: "deliverables",
  label: "Deliverables",
  description: "The files a digital download hands over, and the platforms it is offered on",
  section: {
    component: catalogTabsSection([
      { key: "deliverables", label: "Deliverables", Tab: DeliverablesTab },
      { key: "platforms", label: "Platforms", Tab: PlatformsTab },
    ]),
    label: "Deliverables",
    icon: CloudArrowDownIcon,
    order: 520,
    visible: catalogVisible("deliverables", "platforms"),
  },
  provider: CatalogEditorProvider,
  visibilityContext: useCatalogVisibilityContext,
}
